import React, { useCallback } from 'react';
import { Button } from 'new-design/common/ui/Button';
import { useFormikContext } from 'formik';

export const Submit = ({ children, disabled, ...rest }) => {
  const { isSubmitting, errors, submitForm, setFieldValue } = useFormikContext();

  const handleClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      submitForm();
    },
    [submitForm, setFieldValue]
  );

  return (
    <Button
      {...rest}
      disabled={isSubmitting || Object.values(errors).length > 0 || disabled}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};
